import {Component, Input} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {AdUnitTagPreviewDialogComponent} from './ad-unit-tag-preview-dialog.component';
import {AdUnitPixelTagPreviewDialogComponent} from './ad-unit-pixel-tag-preview-dialog.component';

@Component({
  selector: 'cm-ad-unit-pixel-tag-preview-button',
  template: `
    <button mat-button color="primary"
            *ngIf="pixelTag"
            (click)="openPixelTagPopup(element)"
            class="d-md-none iconed">
      P
      <!--<i class="far fa-code" aria-hidden="true"></i>-->
      <span>Pixel</span>
    </button>
    <button mat-icon-button
            color="primary"
            *ngIf="pixelTag"
            (click)="openPixelTagPopup(element)"
            class="d-none d-md-block"
            matTooltip="Pixel tag" >
      <!--<i class="fas fa-code" aria-hidden="true"></i>-->
    P
    </button>
  `
})
export class AdUnitPixelTagPreviewButtonComponent {

  @Input()
  public adUnitName: string;

  @Input()
  public pixelTag: string;

  constructor(private matDialog: MatDialog) {
  }

  openPixelTagPopup() {
    this.matDialog.open(AdUnitPixelTagPreviewDialogComponent, <MatDialogConfig> {
      data: {
        adUnitName: this.adUnitName,
        pixelTag: this.pixelTag,
      },
      width: '500px'
    });
  }

}
